import { useHistory } from 'react-router-dom';

export const GetAdapterFromUrl = (): string | null => {
  const history = useHistory();

  const searchParams = new URLSearchParams(history.location.search);
  const editParam = searchParams.get('edit');
  return editParam ? decodeURIComponent(editParam) : null;
};
